import { List, ListItem, ListItemText, Typography } from '@mui/material'

import { FplDialog } from 'components/common'
import { ManualDriverInvoiceCandidateDto } from 'generated/graphql'
import { getCandidateSummary, getCandidateTitle } from 'helpers'

interface IProps {
  open: boolean
  loading: boolean
  candidates: Array<ManualDriverInvoiceCandidateDto>
  onCancel: () => void
  onConfirm: () => void
}

export const GenerateInvoiceConfirmDialog = (props: IProps) => {
  const { open, loading, candidates, onCancel, onConfirm } = props

  return (
    <FplDialog
      id='generate-invoice-confirm-dialog'
      open={open}
      caption='Confirm Invoice Generation'
      closeCaption='Cancel'
      submitCaption={`Queue (${candidates.length})`}
      onCloseDialog={onCancel}
      onSaveClick={onConfirm}
      loading={loading}
      fullWidth>
      <Typography>
        These bookings will be queued for invoice and APR generation. Generated invoices cannot be
        deleted.
      </Typography>

      <List dense>
        {candidates.map((candidate) => (
          <ListItem key={candidate.id} disableGutters>
            <ListItemText
              primary={getCandidateTitle(candidate)}
              secondary={getCandidateSummary(candidate)}
            />
          </ListItem>
        ))}
      </List>
    </FplDialog>
  )
}
